import type { ReactNode } from 'react'
import { useAuth } from '@agion/auth'
import { UIVariantProvider } from '@agion/ui/ui-variant'
import { chatUIVariantService } from './ui-variant.service'

// The boot contract lives in @agion/ui/ui-variant, shared with the admin
// console (PLAN-20260929 slices 1 and 2). Mounted around the signed-in tree
// and the not-authorised page; without a signed-in member it keeps the new
// chat and calls nothing (agion/Agion#3210). The sign-in callback never
// resolves one.
export function ChatUIVariantProvider({ children }: { children: ReactNode }) {
  const { user } = useAuth()
  return (
    <UIVariantProvider user={user} service={chatUIVariantService}>
      {children}
    </UIVariantProvider>
  )
}
